import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-religiosos',
  templateUrl: './religiosos.component.html',
  styleUrls: ['./religiosos.component.css']
})
export class ReligiososComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
